import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import CloseIcon from '@mui/icons-material/Close'
import useStyleAssignRole from '../Styles/useStyleAssignRole'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import {
  grantAppRoleToUser,
  updateFirmStaffRoleEAuthz
} from '../../../../../redux/actions/eAuthz'
import { useDispatch } from 'react-redux'
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar
  // setSuccessTextSnackBar
} from '../../../../../redux/actions/app'
import { useState } from 'react'
// import { getUserAppRole } from '../../../../../redux/actions/eAuthz'
import { appRoles } from '../../../../../utils/traducTypes'
import { useNavigate } from 'react-router'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  height: 200,
  bgcolor: 'white',
  p: 4,
  borderRadius: '8px',
  boxShadow: '0px 0px 4px rgba(36, 55, 143, 0.4)'
}

export default function AssignRole ({
  openAssignRole,
  handleCloseAssignRole,
  user,
  userInstance,
  userRol,
  setLoading
}) {
  const [selectedRole, setSelectedRol] = useState(userRol?.appRoleCode || '')
  const classes = useStyleAssignRole()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const handleasignRole = async () => {
    setLoading(true)
    userRol ? await changeRole() : await addRole()
    setLoading(false)
  }
  const reload = () => {
    setTimeout(() => {
      navigate(0)
    }, 3000)
  }
  const addRole = async () => {
    if (userInstance) {
      const newRole = {
        applicationInstanceId: userInstance?.applicationInstanceId,
        roleCode: selectedRole,
        userId: user?.userId,
        suborganizationId: userInstance?.baseSuborganizationId
      }
      const addRoleResponse = await dispatch(grantAppRoleToUser(newRole))

      if (addRoleResponse) {
        dispatch(setSuccessTextSnackBar('Se asignó el rol con éxito'))
        reload()
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error al asignar el rol'))
      }
    }
  }

  const changeRole = async () => {
    if (userRol) {
      const changeRole = {
        applicationInstanceId: userRol.applicationInstanceId,
        previousRoleCode: userRol.appRoleCode,
        roleCode: selectedRole,
        userId: user?.userId,
        suborganizationId: userRol.baseSuborganizationId
      }
      const updateResponse = await dispatch(
        updateFirmStaffRoleEAuthz(changeRole)
      )
      if (updateResponse) {
        dispatch(setSuccessTextSnackBar('Se cambió el rol con éxito'))
        reload()
      } else {
        dispatch(setRequestTextSnackBar())
        dispatch(setErrorTextSnackBar('Ocurrió un error al asignar el rol'))
      }
    }
  }

  return (
    <div>
      <Modal
        open={openAssignRole}
        onClose={handleCloseAssignRole}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: 'medium',
              ml: 50,
              color: '#263057',
              cursor: 'pointer'
            }}
            onClick={handleCloseAssignRole}
          />

          <Typography
            sx={{ fontFamily: 'Raleway', color: '#263057' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Asignar nuevo rol al usuario del Estudio
          </Typography>
          <Typography
            id="modal-modal-description"
            className={classes.typography}
          >
            Seleccione el rol
          </Typography>
          <div className={classes.role}>
            <FormControl fullWidth className={classes.select}>
              <InputLabel id="demo-simple-select-label">
                <span className={classes.label}></span>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedRole}
                onChange={(event) => setSelectedRol(event.target.value)}
              >
                {appRoles.map((appRole) => (
                  <MenuItem key={appRole.value} value={appRole.value}>
                    {appRole.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Box className={classes.buttons}>
            <ButtonConfirm onClick={handleasignRole} />
            <ButtonClose handleCloseAssignRole={handleCloseAssignRole} />
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

function ButtonClose ({ handleCloseAssignRole }) {
  const classes = useStyleAssignRole()
  return (
    <Box className={classes.closeButton}>
      <Typography
        onClick={() => {
          handleCloseAssignRole()
        }}
        className={classes.closeButtonColor}
      >
        Cancelar
      </Typography>
    </Box>
  )
}
function ButtonConfirm ({ onClick }) {
  const classes = useStyleAssignRole()

  return (
    <Box
      className={classes.confirmButton}
      sx={{
        '&:hover': {
          bgcolor: '#1BF57F'
        }
      }}
      onClick={onClick}
    >
      <Typography className={classes.confirmButtonTypography}>
        Confirmar Rol
      </Typography>
    </Box>
  )
}
